import apiHandler from "../core/apiHandler";

const dteSystemApi = apiHandler("dte/system");

export default dteSystemApi;
